<div
  class="spinner-border"
  role="status"
  attr.aria-label="{{ 'general.loading' | translate }}"
  *ngIf="isLoading$ | async"
>
</div>
<form
  [formGroup]="form"
  [patchForm]="sale"
  (ngSubmit)="$event.preventDefault(); onFormSubmit()"
  [canEdit]="[accessRights.Sales_write]"
>
  <div class="mb-3" *ngIf="showSaleStatus" [hidden]="!sale?.id">
    <label class="form-label">
      {{ 'general.status' | translate }}
    </label>

    <select
      formControlName="statusCode"
      class="form-select w-100"
      [attr.aria-invalid]="
        form.controls.statusCode.dirty && form.controls.statusCode.invalid
          ? 'true'
          : null
      "
    >
      <option
        *ngFor="let statusCode of saleStatus"
        [ngValue]="statusCode.value"
      >
        {{ 'saleModule.statusCode' + statusCode.value | translate }}
      </option>
    </select>

    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="form.controls.statusCode.dirty && form.controls.statusCode.invalid"
    >
      <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
      {{ 'general.status' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>

  <div class="mb-3" [ngClass]="{ 'd-flex flex-wrap': sale?.id }">
    <label class="form-label">
      <span
        class="text-danger"
        attr.aria-label="{{ 'general.required' | translate }}"
        *ngIf="!sale?.id"
        >*</span
      >
      {{
        (selectedLanguage$ | async) != 'de'
          ? ('saleModule.customer' | translate)
          : ('general.customer' | translate)
      }}
      <small *ngIf="!sale?.id">({{ 'general.isRequired' | translate }})</small>
    </label>

    <ng-container *ngIf="!sale?.id">
      <member-select-input
        (search)="onSearchMembers($event)"
        [members]="members$ | async"
        formControlName="customerPersonId"
        [allowClearing]="false"
        (ngModelChange)="onChangeMemberSelect($event)"
        [canEdit]="[accessRights.Sales_write]"
        [attr.aria-required]="!sale?.id ? 'true' : 'false '"
      ></member-select-input>
      <p
        class="invalid-feedback"
        role="alert"
        aria-atomic="true"
        *ngIf="
          form.controls?.customerPersonId.dirty &&
          form.controls?.customerPersonId.invalid
        "
      >
        <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
        {{ 'general.customer' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </ng-container>

    <ng-container *ngIf="sale?.id">
      <div class="mx-2 d-flex" *ngIf="userRoles$">
        <p
          class="mb-0 text-black"
          *ngIf="!selectedMember"
          data-test-id="customer-sale"
        >
          {{ getMemberName$(sale?.customerPersonId) | async }}
        </p>
        <p class="mb-0 text-black" *ngIf="selectedMember">
          {{ selectedMember?.firstName }}&nbsp;{{ selectedMember?.lastName }}
        </p>
        <button
          type="button"
          *ngIf="!changeCustomer && selectedOrganization"
          class="btn btn-sm btn-ghost-primary mx-2 mt-n2"
          (click)="changeCustomerbutton()"
        >
          <i
            role="img"
            class="fa fa-edit"
            attr.aria-label="{{ 'general.edit' | translate }}"
          ></i>
        </button>
      </div>
      <div *ngIf="changeCustomer" class="row gx-2 w-100">
        <div class="w-75">
          <ng-select
            [items]="customers"
            bindLabel="name"
            [virtualScroll]="true"
            bindValue="memberId"
            data-testid="customer-select"
            (change)="onMemberClick($event)"
          >
            <ng-template ng-label-tmp ng-option-tmp let-item="item">
              <span data-test-id="customer-select-label">
                {{ item.firstName }}&nbsp;{{ item.lastName }}
              </span>
            </ng-template>
          </ng-select>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-sm btn-soft-success"
            (click)="clickSuccess()"
          >
            <i
              role="img"
              class="fa fa-check fa-fw"
              attr.aria-label="{{ 'general.confirm' | translate }}"
            ></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-soft-danger"
            (click)="clickAbort()"
          >
            <i
              role="img"
              class="fa fa-times fa-fw"
              attr.aria-label="{{ 'general.cancel' | translate }}"
            ></i>
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- customer category form control    -->
  <div
    class="mb-4"
    *ngIf="form.controls.customerCategory && mappedCategoryIdArray?.length"
  >
    <label class="form-label">
      {{ 'saleModule.customerCategory' | translate }}
    </label>

    <select
      formControlName="customerCategory"
      class="form-select"
      data-test-id="create-sale-form-general-customer-category"
    >
      <option
        data-test-id="create-sale-form-general-customer-category-drop-down"
        *ngFor="let cat of this.categories$ | async"
        value="{{ getCategoryValue(cat) }}"
      >
        {{ cat | getCategoryDescription | async }}
      </option>
    </select>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="
        form.controls.customerCategory.dirty &&
        form.controls.customerCategory.invalid
      "
    >
      <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
      {{ 'saleModule.customerCategory' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>

  <div class="mb-4" *ngIf="organizationModuleConfig">
    <label class="form-label">
      {{ 'organizationModule.organization' | translate }}
    </label>

    <ng-select
      data-test-id="create-sale-general-form-organization"
      *ngIf="userRoles$"
      [readonly]="changeCustomer"
      [items]="userRoles$ | async"
      bindLabel="name"
      bindValue="organizationId"
      formControlName="organizationId"
      [loading]="userRolesLoading$ | async"
      data-testid="organization-select"
      [(ngModel)]="selectedOrganization"
      (ngModelChange)="onChangeOrganization($event)"
    >
      <ng-template ng-label-tmp ng-option-tmp let-item="item">
        <span data-test-id="organization-select-label">
          {{
            (organizationEntities$ | async)[item.organizationId]?.description
          }}
          -
          {{ (roleEntities$ | async)[item.roleId]?.description }}
        </span>
      </ng-template>
    </ng-select>

    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="
        form.controls.organizationId.dirty &&
        form.controls.organizationId.invalid
      "
    >
      <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
      {{ 'organizationModule.organization' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>

  <div *ngIf="sale?.id" class="mb-3">
    <label class="form-label">
      {{ 'general.total' | translate }}
    </label>
    <span class="px-2 text-black" data-test-id="sale-total-price">
      {{ sale.total | currency }}
    </span>
  </div>

  <div class="mb-3" *ngIf="!isCreating">
    <label class="form-label">
      {{ 'general.internalNote' | translate }}
    </label>
    <div class="d-flex align-items-start">
      <textarea
        class="form-control"
        (focus)="internalNoteChange()"
        formControlName="internalNote"
        rows="3"
        [attr.aria-invalid]="
          form.controls.internalNote.dirty && form.controls.internalNote.invalid
            ? 'true'
            : null
        "
      ></textarea>
      <button
        class="btn btn-soft-primary btn-sm ms-2"
        *ngIf="sale && (sale | saleFinalStatusCode) === saleStatusCode.DONE"
        type="button"
        [hidden]="!internalNotesChange"
        [canSee]="[accessRights.Sales_write]"
        (click)="internalNotesSave()"
      >
        {{ 'general.save' | translate }}
      </button>
    </div>
  </div>

  <div class="mb-4" *ngIf="saleModuleConfig.orderNumber && !isCreating">
    <label class="form-label">
      {{ 'saleModule.orderNumber' | translate }}
    </label>
    <div class="d-flex align-items-start">
      <input
        class="form-control"
        type="text"
        formControlName="orderNumber"
        (focus)="orderNumberChange()"
        [ngClass]="{
          ' ':
            !(
              form.controls.orderNumber.dirty &&
              form.controls.orderNumber.invalid
            ) &&
            sale &&
            (sale | saleFinalStatusCode) === saleStatusCode.DONE
        }"
      />

      <button
        class="btn btn-soft-primary btn-sm ms-2"
        type="button"
        *ngIf="sale && (sale | saleFinalStatusCode) === saleStatusCode.DONE"
        [hidden]="!orderNumbersChange"
        [canSee]="[accessRights.Sales_write]"
        (click)="orderNumberSave()"
      >
        {{ 'general.save' | translate }}&nbsp;
        {{ 'saleModule.orderNumber' | translate }}
      </button>
    </div>
    <p
      class="invalid-feedback"
      role="alert"
      aria-atomic="true"
      *ngIf="
        form.controls.orderNumber.dirty && form.controls.orderNumber.invalid
      "
    >
      <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
      {{ 'saleModule.orderNumber' | translate }}
      {{ 'general.isInvalid' | translate }}
    </p>
  </div>

  <!-- End Row -->
  <div class="form-footer">
    <button
      type="button"
      class="btn btn-soft-primary btn-sm"
      *ngIf="
        showSubmitButton &&
        (saleHaveUndecidedPayments$ | async) === true &&
        (multidayEnabled$ | async)
      "
      [disabled]="isUpdatingPrices"
      (click)="onClickUpdatePrices()"
      [canSee]="[accessRights.Sales_write]"
    >
      {{ 'saleModule.updatePrices' | translate }}
    </button>

    <button
      type="submit"
      class="btn btn-primary btn-sm"
      *ngIf="showSubmitButton"
      [disabled]="!form.dirty"
      [canSee]="[accessRights.Sales_write]"
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
</form>
